import React, { createContext, useContext, useEffect, useState } from "react";
import http from "../http-common";

const AuthCtx = createContext();
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [isAuth, setIsAuth] = useState(null); // null = loading
  const [userID, setUserID] = useState(null);

  // On load: check session
  useEffect(() => {
    (async () => {
      try {
        const res = await http.get("/api/auth/session");
        if (!res.data?.userID) {
          setIsAuth(false);
          setUserID(null);
          logout();
          return;
        }
        setUserID(res.data.userID);
        setIsAuth(!!res.data?.authenticated);
      } catch {
        setIsAuth(false);
      }
    })();
  }, []);

  const login = async (fullName, username, password) => {
    try {
      const { data } = await http.post("/api/auth/login", {
        fullName,
        username,
        password,
      });
      setUserID(data.userID);
      setIsAuth(true);
    } catch (err) {
      console.log("====================================");
      console.log(err);
      console.log("====================================");

      throw new Error(err?.response?.data?.error || "Login failed");
    }
  };

  const logout = async () => {
    await http.post("/api/auth/logout");
    setIsAuth(false);
  };

  return (
    <AuthCtx.Provider
      value={{ isAuth, userID, loading: isAuth === null, login, logout }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
